<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="indent">
          <!--i v-if="item.equipped" class="fa fa-check-circle subheader"></i-->
          <strong v-if="item.name">
            <a @click="showViewModal = true">
              {{item.name}}
            </a>
          </strong>
          <strong v-else>Item</strong>
          <strong v-if="item.detail">({{ item.detail }})</strong>
          <strong v-if="(item.quantity && item.quantity > 1) || (item.quantity && item.type === 'Currency')"> x{{ item.quantity }}</strong>
        </div>
      </div>
      <div class="col-flex" v-if="canEdit">
        <a :id="`${section}-${item._id}`" @click="$emit('setId')" class="cogs125 modal-toggle">
          <i class="fa fa-cog"></i>
        </a>
      </div>
    </div>

    <ez-modal v-if="showViewModal" @close="showViewModal = false" size="m-medium">
      <display :item="item"></display>
    </ez-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Display from "./_Display.vue";
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "sheet-items-item",
  mixins: [modal],
  components: {
    Display
  },
  props: ["section", "item"],
  data() {
    return {
      showViewModal: false
    };
  },
  watch: {
    item: "updateFromRef"
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  },
  methods: {
    updateFromRef() {
      if (this.item._ref) {
        this.$rpgv.updateFromRef(this.item);
      }
    }
  }
};
</script>
